import React from 'react';
import { StoredCompetitor } from '../../../types/competitors';
import Button from '../../../../../muiComponents/Button';
import useTranslate from '../../../../../customHooks/useTranslate';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';
import IconButton from '../../../../../muiComponents/IconButton';
import { LinearProgress } from '@mui/material';

interface CompetitorRowProps {
    competitor: StoredCompetitor;
    isAnalyzing: boolean;
    actionsDisabled: boolean;
    onAnalyze: (competitor: StoredCompetitor) => void;
    onDelete: (competitor: StoredCompetitor) => void;
}

const CompetitorRow = ({
    competitor,
    isAnalyzing,
    actionsDisabled,
    onAnalyze,
    onDelete,
}: CompetitorRowProps) => {
    const translate = useTranslate();

    return (
        <li className='hotel-presentation__competitor-row'>
            <div className='flex align-items-center'>
                <div className='flex-grow'>
                    <div className='flex flex-align-baseline gap-10'>
                        <p className='hotel-presentation__competitor-name'>
                            {competitor.name}
                        </p>
                        {competitor.city && ' · '}
                        <p className='hotel-presentation__competitor-city'>
                            {competitor.city}
                        </p>
                        {competitor.country && ' · '}
                        <p className='hotel-presentation__competitor-country'>
                            {competitor.country}
                        </p>
                    </div>
                </div>

                <div
                    className='flex gap-5 flex-end'
                    style={{ minWidth: '150px' }}
                >
                    {isAnalyzing ? (
                        <div className='flex flex-column gap-10'>
                            <p>{translate('analyzing_hold')}</p>
                            <LinearProgress
                                aria-label={translate('analyzing_hold')}
                            />
                        </div>
                    ) : (
                        <>
                            <Button
                                color='secondary'
                                disabled={actionsDisabled}
                                onClick={() => onAnalyze(competitor)}
                                startIcon={commonIcons.AI}
                            >
                                {translate('analyze')}
                            </Button>
                            <IconButton
                                className='delete-icon-button'
                                disabled={actionsDisabled}
                                onClick={() => onDelete(competitor)}
                                iconName={commonIcons.DELETE_X}
                            />
                        </>
                    )}
                </div>
            </div>
        </li>
    );
};

export default CompetitorRow;
